import PropertyTable from "./property-table";

const Property = () => {
  return (
    <div className="content-area">
      <PropertyTable />
    </div>
  );
};

export default Property;
